import TourPage from "@/components/TourPage";

export default function DoubleGorilla4Day() {
  return (
    <TourPage
      tourId="rwanda/double-gorilla-4-day"
      title="4 Days Double Gorilla Trekking in Rwanda"
      duration="4 Days / 3 Nights"
      price="Contact for price"
      image="/rwandadoublegorilla.jpeg"
      description="An unforgettable double gorilla trekking experience in Rwanda's Volcanoes National Park, with opportunities to trek to different gorilla families and immerse yourself in Rwandan culture."
      itinerary={[
        {
          day: 1,
          title: "Arrival in Kigali",
          description: "Welcome to Rwanda, the land of a thousand hills.",
          activities: [
            "Airport pickup and transfer to your hotel",
            "Brief city orientation",
            "Evening briefing about your gorilla trekking adventure"
          ],
          accommodation: "Kigali Serena Hotel or similar",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "First Gorilla Trek",
          description: "Your first encounter with the mountain gorillas.",
          activities: [
            "Early morning transfer to Volcanoes National Park",
            "Briefing at park headquarters",
            "Trek to your assigned gorilla family",
            "One hour with the gorillas",
            "Return to lodge for relaxation"
          ],
          accommodation: "Mountain Gorilla View Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Second Gorilla Trek",
          description: "Another magical encounter with a different gorilla family.",
          activities: [
            "Second gorilla trek to a different family",
            "One hour with the gorillas",
            "Afternoon cultural visit to local village",
            "Traditional dance performance"
          ],
          accommodation: "Mountain Gorilla View Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Return to Kigali",
          description: "City tour and departure.",
          activities: [
            "Morning drive to Kigali",
            "City tour including Genocide Memorial",
            "Visit local craft markets",
            "Transfer to airport for departure"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Two gorilla permits",
        "All ground transportation",
        "English speaking guide",
        "Park entrance fees",
        "Accommodation as listed",
        "Meals as specified",
        "Airport transfers",
        "Cultural activities"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips for guides and staff",
        "Drinks and beverages",
        "Activities not mentioned"
      ]}
    />
  );
}
